import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { gungComparatorHelper } from 'gung-common';
import { Subscription } from 'rxjs';
import { BackendPriceLevel, CustomerProductPrice, Price } from '../../models/price';
import { CartService } from '../../services/cart/cart.service';
import { PriceConfigService } from '../../services/price-config/price-config.service';
import { CartRow } from '../../state/cart/types';

@Component({
  selector: 'lib-price-levels',
  templateUrl: './price-levels.component.html',
  styleUrls: ['./price-levels.component.css'],
  standalone: false
})
export class PriceLevelsComponent implements OnInit, OnDestroy {
  priceLevels: BackendPriceLevel[] = [];
  dataCart: CartRow;
  currentPrice = 0;
  cartSubscription: Subscription;

  priceLevelsQuantities: number[] = [];
  priceLevelsPrices: { price: Price, qty: number }[] = [];

  @Input() useStaffedPrice;
  @Input() price;
  @Input() priceLevelsDisplayType: string; // Controls the type of layout of the price levels
  // To display the current price level it will use this quantity instead of the current quantity in cart
  @Input()
  priceLevelsCurrentQty: number;

  constructor(
    protected priceConfigService: PriceConfigService,
    protected cartService: CartService
  ) {}

  ngOnInit(): void {
    if (this.useStaffedPrice) {
      this.initPriceLevels(this.price, this.priceLevelsCurrentQty);
    }

    const priceLevels: BackendPriceLevel[] = (this.price.backendPrice?.levels || []).sort((a, b) => gungComparatorHelper(a.quantity, b.quantity, 1));

    for (let i = 0; i < priceLevels.length; i++) {
      const lvl = priceLevels[i];
      if (lvl.quantity > 0) {
        this.priceLevelsQuantities.push(lvl.quantity);
        this.priceLevelsPrices.push({
          price: {
            value: lvl.price,
            currencyCode: this.price?.customerNetPrice?.currencyCode || 'SEK'
          },
          qty: lvl.quantity
        });
      }
    }
  }

  initPriceLevels(price: CustomerProductPrice, priceLevelsCurrentQty: number = undefined) {
    if (price.backendPrice?.levels) {
      this.priceLevels = price.backendPrice.levels;

      if (price.backendPrice?.levels.length > 1) {
        if (priceLevelsCurrentQty === undefined) {
          this.cartSubscription = this.cartService.getCurrentCart().subscribe(cart => {
            this.dataCart = cart.find(c => c.productId === price.productId);
            if (!this.dataCart) {
              this.currentPrice = 0;
            } else {
              while (
                this.priceLevels[this.currentPrice + 1] &&
                this.dataCart?.qty >= this.priceLevels[this.currentPrice + 1].quantity
              ) {
                this.currentPrice++;
              }

              if (
                this.priceLevels[this.currentPrice] &&
                this.dataCart?.qty < this.priceLevels[this.currentPrice].quantity &&
                this.currentPrice > 0
              ) {
                this.currentPrice--;
              }
            }
          });
        } else {
          if (
            this.priceLevels[this.currentPrice + 1] &&
            priceLevelsCurrentQty >= this.priceLevels[this.currentPrice + 1].quantity
          ) {
            this.currentPrice++;
          }

          if (
            this.priceLevels[this.currentPrice] &&
            priceLevelsCurrentQty < this.priceLevels[this.currentPrice].quantity &&
            this.currentPrice > 0
          ) {
            this.currentPrice--;
          }
        }
      }
    }
  }

  calculatePriceLevelNetPrice(price: number, discount: number): string {
    if (!discount) {
      return this.priceConfigService.getPrice(price, null, null, this.price.customerNetPrice.currencyCode);
    }
    const discountValue: number = price * (discount / 100);
    return this.priceConfigService.getPrice(
      price - discountValue,
      null,
      null,
      this.price.customerNetPrice.currencyCode
    );
    /* return price - discountValue; */
  }

  ngOnDestroy(): void {
    this.cartSubscription?.unsubscribe();
  }
}
